import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ResponseBase} from "../../data";
import {Pod} from "../../data/pod";

export interface PodState {
    response: ResponseBase | null
    loading: boolean,
    error: ResponseBase | null,
    requestFinished: boolean,
    selectedPod: Pod,
    podList: Pod[],
    pod: Pod
}

const initialPodState: PodState = {
    response: null,
    loading: false,
    error: null,
    requestFinished: false,
    selectedPod: {} as Pod,
    podList: [],
    pod: {} as Pod,
}

const podSlice = createSlice({
    name: 'pod',
    initialState: initialPodState,
    reducers: {
        setResponse(state, action: PayloadAction<ResponseBase | null>) {
            state.response = action.payload;
            state.loading = false;
        },
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setSelectedPod(state, action: PayloadAction<Pod>) {
            state.selectedPod = action.payload;
        },
        setPodList(state, action: PayloadAction<Pod[]>){
            state.podList = action.payload;
            state.loading = false;
        },
        setPod(state, action: PayloadAction<Pod>){
            state.pod =  action.payload;
            state.loading = false;
        },
        setError(state, action: PayloadAction<ResponseBase | null>) {
            state.loading = false;
            state.error = action.payload;
        },
        clearPodDetails(state) {
            state.pod = {} as Pod;
        },
        setRequestFinished(state, action:PayloadAction<boolean>) {
            state.requestFinished = action.payload;
            state.loading = false;
        }
    }
});

export const podActions = podSlice.actions;
export default podSlice;
